import CardSafetyAnalysis from "./CardSafetyAnalysis"

export default function PlaceCard({
    place,
    currentLocation,
    showAnalysis,
    mainCard,
    version,
}) {
    return (
        <div id="safety-card-profile" className="h-100">
            <CardSafetyAnalysis
                place={place}
                currentLocation={currentLocation}
            />
        </div>
    )
}
